const Noodl = require('@noodl/noodl-sdk');

// Import CSS from dist folder (fonts.css and icons.css are copied by webpack, not imported here)
import '@prodikt/ui/dist/variables.css';
import '@prodikt/ui/dist/index.css';

// Import component node definitions
const CustomSelectNode = require('./nodes/CustomSelectNode');
const CustomSelectAltNode = require('./nodes/CustomSelectAltNode');
const CustomTextInputNode = require('./nodes/CustomTextInputNode');
const CustomTextAreaNode = require('./nodes/CustomTextAreaNode');
const CustomCheckboxNode = require('./nodes/CustomCheckboxNode');
const CustomToggleNode = require('./nodes/CustomToggleNode');
const CustomButtonNode = require('./nodes/CustomButtonNode');

// Import view node definitions
const ProjectViewNode = require('./nodes/ProjectViewNode');
const ProjectCardNode = require('./nodes/ProjectCardNode');
const ProjectListNode = require('./nodes/ProjectListNode');

// Define and export the module
Noodl.defineModule({
    reactNodes: [
        // Components
        CustomSelectNode,
        CustomSelectAltNode,
        CustomTextInputNode,
        CustomTextAreaNode,
        CustomCheckboxNode,
        CustomToggleNode,
        CustomButtonNode,
        // Views
        ProjectViewNode,
        ProjectCardNode,
        ProjectListNode
    ],
    nodes: [],
    setup() {
        // This is called once on startup
    }
});
